import { IsTouchDevice } from './Ua'

export class hoverMovie {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('.js-course_movie') === null) return
      let movies = Array.prototype.slice.call(document.querySelectorAll('.js-course_movie'), 0)
      const isTouchDevice = IsTouchDevice()

      if (!isTouchDevice) {
        movies.forEach((elm) => {
          elm.addEventListener('mouseenter', (e) => {
            elm.play()
          })
          elm.addEventListener('mouseleave', (e) => {
            elm.pause()
          })
        })
      } else {
        const options = {
          root: null,
          rootMargin: '-35% 0px',
          threshold: 0,
        }

        const doWhenIntersect = function (entries) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play()
            } else {
              entry.target.pause()
            }
          })
        }
        const observer = new IntersectionObserver(doWhenIntersect, options)

        movies.forEach((elm) => {
          observer.observe(elm)
        })
      }
    })
  }
}
